"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeTextDecorationShorthand = exports.openTextDecorationShorthand = void 0;
var tslib_1 = require("tslib");
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
// text-decoration
var openTextDecorationShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'text-decoration',
        parts: [
            { prop: 'text-decoration-color', dataType: css_data_types_1.colorDataType },
            { prop: 'text-decoration-line', dataType: css_data_types_1.textDecorationLineDataType },
            { prop: 'text-decoration-style', dataType: css_data_types_1.textDecorationStyleDataType },
        ],
        shorthandOpener: function (astNodes, api, parts) { return (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(parts)(astNodes, api); },
    });
};
exports.openTextDecorationShorthand = openTextDecorationShorthand;
var closeTextDecorationShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["", " ", " ", ""], ["", " ", " ", ""])), 'text-decoration-color', 'text-decoration-line', 'text-decoration-style'));
};
exports.closeTextDecorationShorthand = closeTextDecorationShorthand;
var templateObject_1;
//# sourceMappingURL=text-decoration-shorthand.js.map